import { updateQueryParameters } from "./updateQueryParameters";

/**
 * Removes query parameter from browser URL
 */
export var removeQueryParameter = function removeQueryParameter(name) {
  var queryParams = new URLSearchParams(window.location.search);
  if (!queryParams.has(name)) {
    return;
  }
  queryParams.delete(name);
  updateQueryParameters(queryParams);
};